/**
 * Created by cookiecoffee on 2018/2/6.
 */
/**
 * 表单校验逻辑
 */

// 表单校验规则
/* eslint-disable */
const validators = {
  required: {
    rule: /.+/,
    msg: '请输入成绩'
  },
  five: {
    rule: /^5$|[0-4](\.\d+)?/,
    msg: '请输入0-5的分数'
  },
  hundred: {
    rule: /^100$|^(\d|[1-9]\d)(\.\d+)*$/,
    msg: '请输入0-100的分数'
  },
  dotduble: {
    rule: /^\d+(\.\d{1,2})?$/,
    msg: '小数点后最多两位'
  },
  dotsingle: {
    rule: /^\d+(\.\d{1})?$/,
    msg: '小数点后最多一位'
  },
  rank: {
    rule: /[A|a,A|a\+,A|a\-,B|b,B|b\+,B|b\-,C|c,C|c\+,C|c\-,D|d,D|d\+,D|d\-,F|f]{1,2}$/,
    msg: '请输入A～F等级分数'
  },
  score: {
    rule: /^100$|^(\d|[1-9]\d)(\.\d+)*$/,
    msg: '请输入合理学分'
  }
}

export const validate = ( e, context ) => {
  const form = {}
  const name = e.currentTarget.dataset.name
  const value = (e.target.value || '').trim ()
  const validator = e.target.dataset.validator ? e.target.dataset.validator.split (',') : []
  if (name) {
    for (let i = 0; i < validator.length; i++) {
      const ruleName = validator[ i ].split ('=')[ 0 ]
      const rule = validators[ ruleName ].rule || /.*/
      form[ name ] = rule.test (value) ? '' : validators[ ruleName ].msg
      if (form[ name ]) break
    }
    context.form = Object.assign({}, context.form, form)
  } else {
    console.error ('缺少name属性值或validator属性值不合法')
  }
}



// WEBPACK FOOTER //
// ./src/libs/validate.js